"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
'kiwi public';

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _setTimeout2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set-timeout"));

var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _flags = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/flags"));

var _lodash = _interopRequireDefault(require("lodash"));

var _state = _interopRequireDefault(require("@/libs/state"));

var Misc = _interopRequireWildcard(require("@/helpers/Misc"));

var bufferTools = _interopRequireWildcard(require("@/libs/bufferTools"));

var _BufferSettings = _interopRequireDefault(require("./BufferSettings"));

var _AwayStatusIndicator = _interopRequireDefault(require("./AwayStatusIndicator"));

var _default = {
  components: {
    BufferSettings: _BufferSettings.default,
    AwayStatusIndicator: _AwayStatusIndicator.default
  },
  props: ['network', 'sidebarState'],
  data: function data() {
    return {
      collapsed: false,
      channel_filter: '',
      channel_filter_display: false,
      channel_add_display: false,
      channel_add_input_has_focus: false,
      channel_add_input: ''
    };
  },
  computed: {
    serverBuffer: function serverBuffer() {
      return this.network.serverBuffer();
    },
    isActiveNetwork: function isActiveNetwork() {
      return _state.default.getActiveNetwork() === this.network;
    },
    totalNetworkCount: function totalNetworkCount() {
      return _state.default.networks.length;
    },
    serverUnread: function serverUnread() {
      var _context;

      if (!this.collapsed) {
        return (0, _flags.default)(this.serverBuffer).unread;
      }

      var totalUnread = 0;
      (0, _forEach.default)(_context = this.network.buffers).call(_context, function (buffer) {
        if (buffer.isSpecial()) {
          return;
        }

        totalUnread += (0, _flags.default)(buffer).unread;
      });
      return totalUnread;
    },
    serverHighlight: function serverHighlight() {
      var _context2;

      if (!this.collapsed) {
        return (0, _flags.default)(this.serverBuffer).highlight;
      }

      var highlight = false;
      (0, _forEach.default)(_context2 = this.network.buffers).call(_context2, function (buffer) {
        if (buffer.isSpecial()) {
          return;
        }

        if ((0, _flags.default)(buffer).highlight) {
          highlight = true;
        }
      });
      return highlight;
    },
    filteredBuffers: function filteredBuffers() {
      var filter = this.channel_filter;
      var filtered = [];

      if (!filter) {
        filtered = this.network.buffers;
      } else {
        filtered = (0, _filter.default)(_lodash.default).call(_lodash.default, this.network.buffers, function (buffer) {
          var name = buffer.name.toLowerCase();
          return (0, _indexOf.default)(name).call(name, filter) > -1;
        });
      }

      return bufferTools.orderBuffers(filtered);
    }
  },
  methods: {
    onNewChannelInputFocus: function onNewChannelInputFocus() {
      // Auto insert the # if no value is already in. Easier for mobile users
      if (!this.channel_add_input) {
        this.channel_add_input = '#';
      }

      this.channel_add_input_has_focus = true;
    },
    onNewChannelInputBlur: function onNewChannelInputBlur() {
      // Remove the # since we may have auto inserted it as they tabbed past
      if (this.channel_add_input === '#') {
        this.channel_add_input = '';
      } // If nothing was entered into the input box, hide it just to clean up the UI


      if (!this.channel_add_input) {
        this.channel_add_display = false;
      }

      this.channel_add_input_has_focus = false;
    },
    submitNewChannelForm: function submitNewChannelForm() {
      var newChannelVal = this.channel_add_input;
      this.channel_add_input = '#';
      var network = this.network;
      var bufferObjs = Misc.extractBuffers(newChannelVal); // Only switch to the first channel we join if multiple are being joined

      var hasSwitchedActiveBuffer = false;
      (0, _forEach.default)(bufferObjs).call(bufferObjs, function (bufferObj) {
        var chanName = bufferObj.name;
        var ignoreNames = ['#0', '0', '&0'];

        if ((0, _indexOf.default)(ignoreNames).call(ignoreNames, chanName) > -1 || chanName.replace(/[#&]/g, '') === '') {
          return;
        }

        var newBuffer = _state.default.addBuffer(network.id, chanName);

        if (newBuffer && !hasSwitchedActiveBuffer) {
          _state.default.setActiveBuffer(network.id, newBuffer.name);

          hasSwitchedActiveBuffer = true;
        }

        if (bufferObj.key) {
          newBuffer.key = bufferObj.key;
        }

        if (network.isChannelName(chanName)) {
          network.ircClient.join(chanName, bufferObj.key);
        }
      });
    },
    onChannelFilterInputBlur: function onChannelFilterInputBlur() {
      var _this = this;

      // Hacky, but if we remove the channel filter UI at this blur event and the user
      // clicked a link in this filter UI, then the click event will not hit the target
      // link as it has been removed before the event reaches it.
      (0, _setTimeout2.default)(function () {
        _this.closeFilterChannel();
      }, 200);
    },
    closeBuffer: function closeBuffer(buffer) {
      _state.default.removeBuffer(buffer);
    },
    awayNotifySupported: function awayNotifySupported() {
      return this.network.ircClient.network.cap.isEnabled('away-notify');
    },
    showMessageCounts: function showMessageCounts(buffer) {
      return !buffer.setting('hide_message_counts');
    },
    setActiveBuffer: function switchContainer(buffer) {
      // Clear any active component to show the buffer again
      _state.default.$emit('active.component', null);

      _state.default.setActiveBuffer(buffer.networkid, buffer.name);

      if (this.$state.ui.is_narrow) {
        _state.default.$emit('statebrowser.hide');
      }
    },
    isActiveBuffer: function isActiveBuffer(buffer) {
      return buffer.networkid === _state.default.ui.active_network && buffer.name === _state.default.ui.active_buffer;
    },
    showNetworkSettings: function showNetworkSettings(network) {
      network.showServerBuffer('settings');
    },
    showNetworkChannels: function showNetworkChannels(network) {
      network.showServerBuffer('channels');
    },
    onSearchChannelClick: function onSearchChannelClick() {
      // If we have no other buffers than the server buffer, take them straight
      // to the channel list for searching
      if (this.network.buffers.length > 1) {
        this.toggleFilterChannel();
      } else {
        this.network.showServerBuffer('channels');
      }
    },
    toggleAddChannel: function toggleAddChannel() {
      this.channel_add_display = !this.channel_add_display;
      this.channel_filter_display = false;
    },
    toggleFilterChannel: function toggleFilterChannel() {
      this.channel_filter_display = !this.channel_filter_display;
      this.channel_add_display = false;
    },
    closeFilterChannel: function closeFilterChannel() {
      this.channel_filter = '';
      this.channel_filter_display = false;
    }
  }
};
exports.default = _default;
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["StateBrowserNetwork"]
window._kiwi_exports.components.StateBrowserNetwork = exports.default ? exports.default : exports;
